const lists = [
  {
    id: 1,
    name: "Food",
  },
  {
    id: 2,
    name: "Desserts",
  },
  {
    id: 3,
    name: "Drinks",
  },
];

export default lists;
